import('./bootstrap')
    .then(
        ({ mount }) => {
            const localRoot = document.getElementById('root');

            mount({
                mountPoint: localRoot!
            });
        }
    )
    .catch(err => {
        console.error('ImportApp not available:', err);
    });

export {};
